import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { FieldRepList } from 'components/Homeowner/FieldReps';
import { getFieldRepListWithRecentlyTerminated, getAllTeamLeaders } from 'actions/homeowner/fieldReps';
import { getStateList } from 'actions/appraiser';
import { FIELDREPPROFILE_VIEW, FIELD_REP_CREATE } from 'typeConstants/rights';
import responseHandler from "responseHandler";

const mapStateToProps = (state) => ({
    ...state.fieldRep,
    fieldReps: state.fieldRep.fieldRepsDetailed,
    isFetchingFRList: state.fieldRep.isFetchingFieldReps,
    stateList: state.appraiser.stateList,
    allTeamLeaders: state.fieldRep.allTeamLeaders,
    canView: state.user.profile.rights.includes(FIELDREPPROFILE_VIEW),
    canCreate: state.user.profile.rights.includes(FIELD_REP_CREATE),
});

const mapDispatchToProps = (dispatch) => ({
    getFieldRepList(search) {
        dispatch(getFieldRepListWithRecentlyTerminated(search));
    },
    getStateList() {
        dispatch(getStateList());
    },
    getAllTeamLeaders() {
        dispatch(getAllTeamLeaders());
    },
    makeToast(text, level) {
        if (!level) level = "success";
        responseHandler.noHideCustomToast(text, level, dispatch);
    }
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FieldRepList));
